import { createFileRoute } from "@tanstack/react-router";
import { permanentRedirect } from "@/lib/legacyRedirects";

/**
 * Elbolagens landningssidor bor numera enbart under /elhandel/<slug>.
 * Gamla /elbolag/<slug> pekas om permanent för att undvika dubbletter.
 */
export const Route = createFileRoute("/elbolag/$slug")({
  beforeLoad: ({ params }) => permanentRedirect(`/elhandel/${params.slug}`),
});
